import { Icon, IconProps } from "../";

export const ArrowBackBriefIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7996 4.98966C16.0814 5.2932 16.0639 5.76775 15.7603 6.0496L9.35221 12L15.7603 17.9504C16.0639 18.2323 16.0814 18.7068 15.7996 19.0103C15.5177 19.3139 15.0432 19.3314 14.7397 19.0496L7.73966 12.5496C7.58683 12.4077 7.5 12.2086 7.5 12C7.5 11.7915 7.58683 11.5923 7.73966 11.4504L14.7397 4.95041C15.0432 4.66856 15.5177 4.68613 15.7996 4.98966Z"
      />
    </Icon>
  );
};
